import {
  AccountPage,
  Loader,
  ToastCluster,
} from '@skf/bt-wind-rail-commonlibrary';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { goToUrl } from '../../../services/location/locationService';
import { getSettings } from '../../../services/settingsService';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../store/store';
import { ToastMessage } from '@skf/bt-wind-rail-commonlibrary/dist/components/common/toastCluster/ToastCluster';
import { IUserSettingsState } from '../../../store/userSettings/store';
import {
  fetchAccountSettings,
  putAccountSettings,
} from '../../../store/userSettings/actions';
import { useLoadingScreen } from '../../../hooks/useLoadingScreen';

const SettingsPage: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { setLoading } = useLoadingScreen();
  const settings = getSettings();

  const [_toastMessage, setToastMessage] = useState<ToastMessage>();

  const settingsState: IUserSettingsState = useSelector<
    StoreState,
    IUserSettingsState
  >((state) => state.userSettings);

  useEffect(() => {
    if (
      settingsState.accountSettings === undefined &&
      settingsState.isFetching === false
    ) {
      dispatch(fetchAccountSettings());
    }
  }, []);

  useEffect(() => {
    setLoading(settingsState.isFetching === true);
  }, [settingsState.isFetching]);

  //   if (settingsState.isFetching === true) {
  //     return (
  //       <Loader show={settingsState.isFetching === true} fullscreen={true} />
  //     );
  //   }

  if (settingsState.accountSettings === undefined) return null;

  return (
    <>
      <ToastCluster toastMessage={_toastMessage} />
      <AccountPage
        translate={t}
        onClickChangePassword={
          () => {}
          // goToUrl(settings.loginWebUrl + '?changePsw=true')
        }
        onClickSaveSettings={(newSettings) => {
          setToastMessage({
            message: t('Settings_Saving'),
            status: 'ok',
          });
          const okSettings = () => {
            setToastMessage({
              message: t('Settings_Saved'),
              status: 'ok',
            });
          };
          const failedSettings = () => {
            setToastMessage({
              message: t('Settings_Error'),
              status: 'danger',
            });
          };
          dispatch(putAccountSettings(newSettings, okSettings, failedSettings));
        }}
        userSettings={settingsState.accountSettings}
      />
    </>
  );
};

export default SettingsPage;
